import { defineStore } from 'pinia'
import { getPriceTable } from '@/features/printstore/PrintStoreApi'

export const usePriceTableStore = defineStore('priceTable', {
  state: () => ({
    priceTable: {
      A5M01: 5.55,
      A5M02: 7.41,
      A5M03: 12.98,
      A5M04: 17.61,
      A5M05: 26.88,
      A5M06: 12.98,
      '65A4M01': 7.5,
      '65A3M01': 10.24,
      '65A3M02': 13.65,
      '65A3M03': 23.89,
      '65A3M04': 32.43,
      '65A3M05': 49.49,
      '65A3M06': 23.89,
      '6515M01': 4.77,
      '6515M02': 6.67,
      '6515M03': 11.43,
      '6515M04': 15.24,
      '6515M05': 22.85,
      '6515M05T': 23.35,
      '6515M06': 11.43,
      '6525M01': 6.35,
      '6525M02': 8.89,
      '6525M03': 15.24,
      '6525M04': 20.31,
      '6525M05': 30.47,
      '6525M06': 15.24,
      '6540M01': 9.52,
      '6540M02': 13.33,
      '6540M03': 22.85,
      '6540M04': 30.47,
      '6540M05': 45.71,
      '6540M05T': 46.21,
      '6540M06': 22.85,
      '6570M01': 22.22,
      '6570M02': 31.11,
      '6570M03': 53.33,
      '6570M04': 71.1,
      '6570M05': 106.65,
      '6570M06': 53.33,
      '6570M07': 152.05,
      '6515CM01': 5.96,
      '6515CM02': 8.33,
      '6515CM03': 14.29,
      '6515CM04': 19.05,
      '6515CM05': 28.57,
      '6515CM05T': 29.07,
      '6515CM06': 14.29,
      '6525CM01': 7.93,
      '6525CM02': 11.11,
      '6525CM03': 19.05,
      '6525CM04': 25.39,
      '6525CM05': 38.09,
      '6525CM06': 19.05,
      '6540CM01': 11.9,
      '6540CM02': 16.67,
      '6540CM03': 28.57,
      '6540CM04': 38.09,
      '6540CM05': 57.14,
      '6540CM06': 28.57,
      '6560CM01': 18.87,
      '6560CM02': 26.53,
      '6560CM03': 45.47,
      '6560CM04': 60.76,
      '6560CM05': 91.13,
      '6560CM06': 45.47,
      '6570CM01': 27.78,
      '6570CM02': 38.88,
      '6570CM03': 66.66,
      '6570CM04': 88.88,
      '6570CM05': 133.32,
      '6570CM06': 66.66,
      '6570CM07': 160.93,
      C19PNLM1: 50.0,
      C19BRDM1: 15.0,
      'DEMO-PAKKET': 0.0,
      'DEMO-KANTOOR': 0.0,
      'DEMO-RETAIL': 0.0,
      'DEMO-VERKEER': 0.0,
      'DEMO-ONDERWIJS': 0.0,
      'DEMO-GEMEENTE': 0.0,
      'DEMO-EVENEMENT': 0.0,
      SVA41: 8.65,
      SVA420: 147.2,
      SVA450: 324.5,
      SVA4100: 563,
      SVA4250: 1082.5,
      SVA4C1: 11.25,
      SVA4C20: 191.36,
      SVA4C50: 421.85,
      SVA4C100: 731.9,
      SVA4C250: 1407.25,
      SVA4C1GL: 11.25,
      SVA4C20GL: 191.36,
      SVA4C50GL: 421.85,
      SVA4C100GL: 731.9,
      SVA4C250GL: 1407.25,
      XSVA41: 7.5,
      XSVA420: 100.0,
      XSVA450: 148.5,
      XSVA4100: 259.5,
      XSVA4250: 563.1,
      XSVA4C1: 11.25,
      XSVA4C20: 149.75,
      XSVA4C50: 199.5,
      XSVA4C100: 284.75,
      XSVA4C250: 619.95,
      'AZ-S-15': 100.78,
      '30019M06': 71.23,
      '150120WBM': 277.12,
      '150120WBS': 205.29,
      '150120WBSM': 281.16,
      '10060WBM': 150.15,
      '100120WBM': 210.14,
      '100120WBS': 141.73,
      '100120WBSM': 193.21,
      '120200WBM': 335.22,
      '120200WBS': 268.85,
      '120200WBSM': 369.06,
      '235115WBS': 275.34,
      '235115WBSM': 388.35,
      A1WBS: 69.16,
      A7CM01: 4.91,
      A7CM02: 6.55,
      A7CM03: 11.46,
      A7CM04: 15.55,
      A7CM05: 23.73,
      A7CM06: 11.46,
      A2M01: 12.74,
      A2M02: 16.98,
      A2M03: 29.72,
      A2M04: 40.34,
      A2M05: 61.57,
      A2M06: 29.72,
      '12575M011': 2.4,
      '12575M0125': 51.25,
      '12575M0150': 90,
      '12575M01100': 165,
      '1000400M01': 18.23,
      '1000400M02': 24.3,
      '1000400M03': 42.53,
      '1000400M04': 57.71,
      '1000400M05': 88.09,
      '1000400M06': 42.53,
      PA3815PW: 7.5,
      '335175BHM': 149.75,
      '335175BHB': 149.75,
      '2000800M05': 391.24
    }
  }),
  actions: {
    setPriceTable(table) {
      Object.assign(this.priceTable, table)
    },
    async hydrate(val) {
      const response = await getPriceTable(val)
      this.setPriceTable(response)
    }
  }
})
